import { Link } from 'react-router-dom';
import { ArrowLeftRight, Trash2, X } from 'lucide-react';
import { Button } from './ui/button';
import { useCompare } from '../contexts/CompareContext';
import { useLanguage } from '../contexts/LanguageContext';

export const CompareTray = () => {
  const { t, isRTL } = useLanguage();
  const { compareCars, canOpenComparison, clearCompare, removeFromCompare, maxCompareCars } = useCompare();
  const startIconMarginClass = isRTL ? 'ml-2' : 'mr-2';

  if (compareCars.length === 0) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-24 z-40 px-4 md:bottom-6">
      <div className="pointer-events-auto mx-auto flex w-full max-w-5xl flex-col gap-4 rounded-3xl border border-[#D4AF37]/30 bg-black/95 p-4 shadow-2xl shadow-black/40 backdrop-blur-xl md:flex-row md:items-center md:justify-between md:p-5">
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#D4AF37] text-black">
              <ArrowLeftRight className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-white">
                {t('compare.trayTitle', 'Compare Cars')}
              </p>
              <p className="text-xs text-white/60">
                {compareCars.length}/{maxCompareCars} {t('compare.selected', 'selected')}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {compareCars.map((car) => (
              <div
                key={car.id}
                className="flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-2 text-sm text-white/80"
              >
                <span className="max-w-[10rem] truncate">{car.brand} {car.model}</span>
                <button
                  type="button"
                  onClick={() => removeFromCompare(car.id)}
                  className="rounded-full border border-white/10 bg-white/5 p-1 text-white/45 transition-colors hover:border-white/20 hover:bg-white/10 hover:text-white"
                  aria-label={t('compare.remove', 'Remove from comparison')}
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-2 md:w-auto md:min-w-[14rem]">
          <Button
            type="button"
            variant="outline"
            onClick={clearCompare}
            className="border-white/15 bg-white/5 text-white/70 hover:border-red-400/30 hover:bg-red-500/10 hover:text-red-200"
          >
            <Trash2 className={`${startIconMarginClass} h-4 w-4`} />
            {t('compare.clear', 'Clear comparison')}
          </Button>

          {canOpenComparison ? (
            <Button asChild className="btn-gold text-black">
              <Link to="/compare">
                <ArrowLeftRight className={`${startIconMarginClass} h-4 w-4`} />
                {t('compare.open', 'Open comparison')}
              </Link>
            </Button>
          ) : (
            <Button type="button" disabled className="btn-gold text-black disabled:opacity-60">
              {t('compare.addMore', 'Add one more car')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompareTray;
